import styled from 'styled-components';
import theme from './theme/index';
import { typography } from './theme/index';

// Layout Components
export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100vw;
  background-color: ${theme.colors.background};
  overflow: hidden;
  margin: 0;
  padding: 0;
  position: relative;
  box-sizing: border-box;
`;

export const FormSection = styled.div`
  flex: 1;
  width: 480px;
  padding: ${theme.spacing.xxxl} ${theme.spacing.xxl} ${theme.spacing.xxl};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
`;

export const TestimonialSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${require('../assets/images/testimonial-background.jpg')});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 50%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 62, 73, 0.5);
  }

  /* Ensure content stays above the overlay */
  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    display: none;
  }
`;

// Typography Components
export const BrandText = styled.span`
  font-family: 'Source Serif 4', sans-serif;
  font-weight: 400;
  font-style: italic;
`;

export const Title = styled.h1`
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.medium};
  font-size: ${theme.typography.fontSize.xxl};
  color: ${theme.colors.primary};
  margin: 0 auto ${theme.spacing.lg};
  text-align: left;
  line-height: 1.3;
  width: 90%;
`;

export const Text = styled.p`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.base};
  color: ${theme.colors.text.secondary};
  line-height: ${theme.typography.lineHeight.relaxed};
`;

// Form Components
export const Form = styled.form`
  width: 90%;
  margin: ${theme.spacing.md} auto 0;
`;

export const FormContainer = styled.div`
  max-width: 600px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormFields = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 24px;
`;

export const CompanyDisplay = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
  width: 100%;
  align-items: center;
  text-align: center;
`;

export const CompanyValue = styled.div`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.primary};
  font-weight: ${theme.typography.fontWeight.medium};
  background: ${theme.colors.accent}20;
  padding: 6px 24px;
  border-radius: 16px;
  display: inline-block;
`;

export const FormFooter = styled.div`
 font-family: ${typography.fontFamily};
  margin-top: ${theme.spacing.xl};
  text-align: center;
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.text.secondary};
`;

export const Link = styled.a`
  color: ${theme.colors.primary};
  text-decoration: none;
  font-weight: ${theme.typography.fontWeight.medium};
  
  &:hover {
    text-decoration: underline;
  }
`;

// Input Components
export const InputWrapper = styled.div`
  margin-bottom: ${theme.spacing.lg};
  position: relative;
`;

export const Label = styled.label`
  display: block;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.text.secondary};
  margin-bottom: 8px;
  font-weight: ${theme.typography.fontWeight.medium};
`;

export const Input = styled.input`
  width: 100%;
  padding: ${theme.spacing.md};
  border: 1px solid ${theme.colors.border};
  border-radius: 4px;
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.text.primary};
  transition: ${theme.transitions.default};
  box-sizing: border-box;
  height: 48px;
  
  &:focus {
    border-color: ${theme.colors.primary};
    outline: none;
    box-shadow: ${theme.shadows.focus};
  }

  &::placeholder {
    color: ${theme.colors.text.placeholder};
  }
`;

export const ErrorMessage = styled.span`
  color: ${theme.colors.text.error};
  font-size: ${theme.typography.fontSize.xs};
  margin-top: ${theme.spacing.xs};
  display: block;
`;

// Button Component
export const Button = styled.button`
  width: 100%;
  padding: ${theme.spacing.md};
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  border: none;
  border-radius: 4px;
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.semibold};
  font-size: ${theme.typography.fontSize.base};
  cursor: pointer;
  transition: ${theme.transitions.default};
  box-sizing: border-box;
  height: 48px;
  display: block;
  margin: 0;
  
  &:hover {
    background-color: ${theme.colors.primaryHover};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

// Testimonial Components
export const SectionTitle = styled.h2`
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.semibold};
  font-size: ${theme.typography.fontSize.xl};
  color: ${theme.colors.text.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
`;

export const TestimonialAvatar = styled.img`
  width: 160px;
  height: 160px;
  border-radius: 12px;
  margin-bottom: -20px;
  object-fit: cover;
`;

export const TestimonialCard = styled.div`
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  padding: ${theme.spacing.xl};
  max-width: 480px;
  box-shadow: ${theme.shadows.md};
  text-align: center;
  margin: ${theme.spacing.xxxl};
`;

export const CompanyLogo = styled.img`
  width: 120px;
  opacity: 0.8;
  height: auto;
  margin-top: ${theme.spacing.xl};
  opacity: 0.9;
`;

export const QuoteWrapper = styled.div`
  position: relative;
  margin: ${theme.spacing.xl} 0;
`;

export const QuotationMark = styled.img`
  position: absolute;
  width: 50px;
  height: auto;
  opacity: 0.1;

  &.start {
    top: -25px;
    left: 0px;
    transform: rotate(180deg);
  }

  &.end {
    bottom: 0px;
    right: 0px;
  }
`;

export const Quote = styled.blockquote`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.light};
  line-height: ${theme.typography.lineHeight.relaxed};
  color: ${theme.colors.text.primary};
  margin: 0;
  position: relative;
  opacity: 0.9;
  padding: ${theme.spacing.lg};
`;

export const Author = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.sm};
  margin-top: -${theme.spacing.md};
`;

export const AuthorImage = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${theme.colors.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.white};
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: ${theme.typography.fontSize.xl};
`;

export const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const AuthorName = styled.div`
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.semibold};
  font-size: ${theme.typography.fontSize.xl};
  margin-bottom: 8px;
  color: ${theme.colors.text.primary};
  text-align: center;
`;

export const AuthorRole = styled.div`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.text.secondary};
  text-align: center;
`;

export const LogoWrapper = styled.div`
  width: 90%;
  margin: 0 auto ${theme.spacing.xl};
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid ${theme.colors.border};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.sm};
`;

export const AutocompleteItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  color: ${theme.colors.text.primary};
  transition: background-color 0.2s ease;

  &:hover {
    background: ${theme.colors.accent}20;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.border}20;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  width: 100%;
  align-items: ${props => props.alignItems || 'center'};
  justify-content: ${props => props.justifyContent || 'flex-start'};
`;

export const ConsentCheckboxWrapper = styled.div`
  font-family: ${theme.typography.fontFamily};
  margin: ${theme.spacing.md} 0;
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.sm};
`;

export const ConsentCheckbox = styled.input.attrs({ type: 'checkbox' })`
  margin-top: -3px;
  vertical-align: top;
`;

export const ConsentText = styled.label`
  text-align: left;
  font-size: ${theme.typography.fontSize.xs};
  color: ${theme.colors.text.secondary};
  cursor: pointer;
  vertical-align: top;
  display: inline-block;
`; 